
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: SpesaFurba.ts;
 * Path: ./src/environments/BaseEnvironments/SpesaFurba.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 24/01/25, 10:49;
 * Updated at: 24/01/25, 10:49;
 *
 */

import { ApiPathsService } from 'src/app/api-paths.service';
import { Prodotti } from '../Modules/Prodotti';
import { getModule, addModule } from '../Utility/ModuleUtility';
import { Fornitori } from '../Modules/Fornitori';
import { Listino } from '../Modules/Listino';
import { NotificheEnv } from '../Modules/Notifiche';
var Environment = () => {
  var env: any = {};
  env.langSuffix = '_SpesaFurba.json';
  env.style = 'FortyFix';
  env.MainColor = '#00ee00';
  env.navbarbg = '#FFFFFF';
  env.navbarAccentColor = '#62C4E6';
  env.InputTextColor = "#135666";
  env.baseUrl = '/listino/listini';
  env.sidebarbg = 'skin6';

  env.theme = 'light';
  env = addModule(Marche(), env);
  env = addModule(Fornitori(), env);
  env = addModule(Prodotti(), env);
  env = addModule(Listino(), env);
  env = addModule(NotificheEnv(), env);
  env = addModule({
    Modules: {
      "Stampe": true,
    },
    ClientiAddOn: {
      noapionmap:true,
      sedi: true,
      hideFax: true,
      AliasSede:true,
    },
    ProdottiAddOn: {
      hideIva: true,
      export:true,
      um: true,
      AutocompleteName: true,
      HideCat: true,
      prodottiFilter: [
        { nome: "Cerca", oggetti: ['pdv'], type: "text", class: 'col-lg-9' },
        { nome: "Marca", oggetti: ['marca'], type: "text", class: 'col-lg-3'}
      ],
      ProdottiListHeader: [
        { nome: "Prodotto", oggetti: ["prodotto"], type: 'text' },
      ],
      CampiAggiuntivi: [
        {
          nome: 'Categoria',
          oggetti: ['categorie'],
          source: '/prodotti/categorie/list',
          parameter: [],
          modificabile: true,
          required: true,
          disabledif: { func: (x) => { return true } },
          type: 'CategoriaNavHorizontal',
          inputType: 'objectArray',
          class: "col-lg-12 pr-0",
        },
        {
          nome: 'Confezione',
          htmlTooltip: `inserisci il valore in ml o in gr del prodotto`,
          oggetti: ['quantita'],
          modificabile: true,
          inputType: 'number',
          class: "col-lg-3"
        },
        {
          nome: 'Esclusiva',
          oggetti: ['esclusiva'],
          source: '/anagrafica/clienti/list',
          parameter: [{ nome: 'page', value: 0 }, { nome: 'size', value: 100 }, { nome: 'ruolo', value: 'F' }],
          responseHasData:true,
          modificabile: true,
          class: "col-lg-3",
          internalOutput: 'esclusivaObject',
          inputType: 'singleDropdown',
          OutputField: 'esclusiva',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'nominativo',
            allowSearchFilter: true,
          },
        },
        {
          nome: 'Ean',
          oggetti: ['ean'],
          modificabile: true,
          class: "col-lg-3"
        },

      ]
    }
  }, env);
  env.ProdottiAddOn
  return env;
};

var Marche = () => {
  return {
    ProdottiAddOn: {
      ProdottiListHeader: [
        { nome: "Marca", oggetti: ["marcaObject"], type: 'object', field: ['label'] },
      ],
      CampiAggiuntivi: [
        {
          nome: 'Marca',
          source: '/settings/get',
          parameter: [{ nome: 'id', value: 'marca_prodotto' }, { nome: 'type', value: 'marca_prodotto' }],
          oggetti: ['idMarca'],
          modificabile: true,
          class: "col-lg-3",
          internalOutput: 'marcaObject',
          inputType: 'singleDropdown',
          OutputField: 'idMarca',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label',
            allowSearchFilter: true,
            moreButton: true,
            moreButtonText: "Inserisci",
          },
          onMore: (x, api: ApiPathsService, permission, campo, callback: (x) => void) => {
            api.ClassicPost('/settings/add', { label: x.label, type: 'marca_prodotto' }).subscribe(data => {
              if (!data?.id) return;
              callback(data);
            });
          }
        }
      ]
    },
    Menu: [
      {
        module: "Settings",
        title: "Settings",
        icon: "fas fa-cogs",
        class: "has-arrow",
        capacita: [],
        submenu: [
          {
            path: "/settings/setting/marca_prodotto",
            title: "Marche",
            capacita: []
          },
        ]
      },
    ]
  }
}

var FullEnv = () => {
  var env: any = {};
  env.baseUrl = '/progetti/prodotti/lista';
  env.langSuffix= '_SpesaFurba.json',
  env = getModule(Environment());
  return env;
};

export var environment: any = FullEnv();
